import React, { useEffect } from 'react';
import Head from './Head';
import { IComponentSlideHead } from '../../component';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import { getPageSameType } from '../../utils/util';

const AllForXHead = (props: IComponentSlideHead) => {
  let { pagedataStore } = props.rootStore;
  const summaryPage = getPageSameType((window.pageDetail && window.pageDetail.template) || [], [], 'tagphoto').length > 0;
  const mainGalleryId = window.gallery && String(window.gallery.id);
  useEffect(() => {
    if (!props.total || !summaryPage || !mainGalleryId) return;
    pagedataStore.loadMainGalleryViews(mainGalleryId).catch(error => {
      console.warn('图片汇总页主相册浏览量加载失败', error);
    });
  }, [pagedataStore, props.total, summaryPage, mainGalleryId]);

  const statistics = pagedataStore.getViewDetail();
  return <Head {...props} {...statistics} {...(summaryPage && mainGalleryId
    ? { imageviews: pagedataStore.mainGalleryViews[mainGalleryId] || 0 }
    : {})} />;
};

export default inject('rootStore')(observer(AllForXHead));
